import { useState, useEffect } from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text } from '@pancakeswap/uikit'
import { ethers } from 'ethers'
import abi from '../../../abi/lottery.abi.json'

const StyledCard = styled(Flex)`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-shadow: ${({ theme }) => (theme.isDark ? '' : '8px 12px 12px rgba(15, 20, 30, 0.12)')};
`

const StyledSoftText = styled(Text)`
  color: ${({ theme }) => theme.colors.softTextColor};
`

const PrizeAllocation = ({ genericprovider }) => {
  const theme = useTheme()
  const contractAddress = '0x043C2e5100A7157c36D677af0BbD62F76bB7E7D7'

  return (
    <StyledCard style={{ flexDirection: 'column' }}>
      <Flex
        width="100%"
        style={{
          background: theme.isDark ? '#19233F' : '#F5F6F8',
          paddingLeft: '5%',
          paddingRight: '5%',
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        }}
      >
        <StyledSoftText style={{ flexGrow: 1, marginTop: 20, marginBottom: 20 }}>Result</StyledSoftText>
        <StyledSoftText style={{ marginTop: 20 }}>Prize allocations</StyledSoftText>
      </Flex>
      <Flex width="100%" style={{ paddingLeft: '5%', paddingRight: '5%', paddingTop: 20, paddingBottom: 20 }}>
        <StyledSoftText style={{ flexGrow: 1 }}>6 Match</StyledSoftText>
        <Text>Jackpot + BAYC #9419</Text>
      </Flex>
      <Flex
        width="100%"
        style={{
          background: theme.isDark ? '#19233F' : '#F5F6F8',
          paddingLeft: '5%',
          paddingRight: '5%',
          paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        <StyledSoftText style={{ flexGrow: 1 }}>5 Match</StyledSoftText>
        <Text>$32,000 USDT</Text>
      </Flex>
      <Flex width="100%" style={{ paddingLeft: '5%', paddingRight: '5%', paddingTop: 20, paddingBottom: 20 }}>
        <StyledSoftText style={{ flexGrow: 1 }}>4 Match</StyledSoftText>
        <Text>$300 USDT</Text>
      </Flex>
      <Flex
        width="100%"
        style={{
          background: theme.isDark ? '#19233F' : '#F5F6F8',
          paddingLeft: '5%',
          paddingRight: '5%',
          paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        <StyledSoftText style={{ flexGrow: 1 }}>3 Match</StyledSoftText>
        <Text>$25 USDT</Text>
      </Flex>
      <Flex width="100%" style={{ paddingLeft: '5%', paddingRight: '5%', paddingTop: 20, paddingBottom: 20 }}>
        <StyledSoftText style={{ flexGrow: 1 }}>2 Match</StyledSoftText>
        <Text>$5 USDT</Text>
      </Flex>
      <Flex
        width="100%"
        style={{
          background: theme.isDark ? '#19233F' : '#F5F6F8',
          paddingLeft: '5%',
          paddingRight: '5%',
          paddingTop: 20,
          paddingBottom: 20,
          borderBottomLeftRadius: 16,
          borderBottomRightRadius: 16,
        }}
      >
        <StyledSoftText style={{ flexGrow: 1 }}>1 Match</StyledSoftText>
        <Text>$0 USDT</Text>
      </Flex>
    </StyledCard>
  )
}

export default PrizeAllocation
